import { useState } from 'react';
import { share } from '../data';

// Donor-wall message cap. Mirrors the server's own limit (server/gramsci.js) —
// this is the courtesy, not the enforcement.
export const MESSAGE_MAX_LEN = 40;

// Brand glyphs, white fill (sit inside a dark circular badge per the design).
// Official multi-tone brand mark (gradient + white glyph) rather than a flat
// fill — a single flat pink reads too close to the card's purple background.
const InstagramIcon = () => (
  <svg viewBox="0 0 3364.7 3364.7" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="ig-grad-warm" cx="217.76" cy="3290.99" r="4271.92" gradientUnits="userSpaceOnUse">
        <stop offset=".09" stopColor="#fa8f21" />
        <stop offset=".78" stopColor="#d82d7e" />
      </radialGradient>
      <radialGradient id="ig-grad-cool" cx="2330.61" cy="3182.95" r="3759.33" gradientUnits="userSpaceOnUse">
        <stop offset=".64" stopColor="#8c3aaa" stopOpacity="0" />
        <stop offset="1" stopColor="#8c3aaa" />
      </radialGradient>
    </defs>
    <path d="M853.2,3352.8c-200.1-9.1-308.8-42.4-381.1-70.6-95.8-37.3-164.1-81.7-236-153.5S119.7,2988.6,82.6,2892.8c-28.2-72.3-61.5-181-70.6-381.1C2,2295.4,0,2230.5,0,1682.5s2.2-612.8,11.9-829.3C21,653.1,54.5,544.6,82.5,472.1,119.8,376.3,164.3,308,236,236c71.8-71.8,140.1-116.4,236-153.5C544.3,54.3,653,21,853.1,11.9,1069.5,2,1134.5,0,1682.3,0c548,0,612.8,2.2,829.3,11.9,200.1,9.1,308.6,42.6,381.1,70.6,95.8,37.1,164.1,81.7,236,153.5s116.2,140.2,153.5,236c28.2,72.3,61.5,181,70.6,381.1,9.9,216.5,11.9,281.3,11.9,829.3,0,547.8-2,612.8-11.9,829.3-9.1,200.1-42.6,308.8-70.6,381.1-37.3,95.8-81.7,164.1-153.5,235.9s-140.2,116.2-236,153.5c-72.3,28.2-181,61.5-381.1,70.6-216.3,9.9-281.3,11.9-829.3,11.9-547.8,0-612.8-1.9-829.1-11.9" fill="url(#ig-grad-warm)" />
    <path d="M853.2,3352.8c-200.1-9.1-308.8-42.4-381.1-70.6-95.8-37.3-164.1-81.7-236-153.5S119.7,2988.6,82.6,2892.8c-28.2-72.3-61.5-181-70.6-381.1C2,2295.4,0,2230.5,0,1682.5s2.2-612.8,11.9-829.3C21,653.1,54.5,544.6,82.5,472.1,119.8,376.3,164.3,308,236,236c71.8-71.8,140.1-116.4,236-153.5C544.3,54.3,653,21,853.1,11.9,1069.5,2,1134.5,0,1682.3,0c548,0,612.8,2.2,829.3,11.9,200.1,9.1,308.6,42.6,381.1,70.6,95.8,37.1,164.1,81.7,236,153.5s116.2,140.2,153.5,236c28.2,72.3,61.5,181,70.6,381.1,9.9,216.5,11.9,281.3,11.9,829.3,0,547.8-2,612.8-11.9,829.3-9.1,200.1-42.6,308.8-70.6,381.1-37.3,95.8-81.7,164.1-153.5,235.9s-140.2,116.2-236,153.5c-72.3,28.2-181,61.5-381.1,70.6-216.3,9.9-281.3,11.9-829.3,11.9-547.8,0-612.8-1.9-829.1-11.9" fill="url(#ig-grad-cool)" />
    <path d="M1269.25,1689.52c0-230.11,186.49-416.7,416.6-416.7s416.7,186.59,416.7,416.7-186.59,416.7-416.7,416.7-416.6-186.59-416.6-416.7m-225.26,0c0,354.5,287.36,641.86,641.86,641.86s641.86-287.36,641.86-641.86-287.36-641.86-641.86-641.86S1044,1335,1044,1689.52m1159.13-667.31a150,150,0,1,0,150.06-149.94h-0.06a150.07,150.07,0,0,0-150,149.94M1180.85,2707c-121.87-5.55-188.11-25.85-232.13-43-58.36-22.72-100-49.78-143.78-93.5s-70.88-85.32-93.5-143.68c-17.16-44-37.46-110.26-43-232.13-6.06-131.76-7.27-171.34-7.27-505.15s1.31-373.28,7.27-505.15c5.55-121.87,26-188,43-232.13,22.72-58.36,49.78-100,93.5-143.78s85.32-70.88,143.78-93.5c44-17.16,110.26-37.46,232.13-43,131.76-6.06,171.34-7.27,505-7.27S2059.13,666,2191,672c121.87,5.55,188,26,232.13,43,58.36,22.62,100,49.78,143.78,93.5,58.35,58.35,70.78,85.42,93.5,143.78,17.16,44,37.46,110.26,43,232.13,6.06,131.87,7.27,171.34,7.27,505.15s-1.21,373.28-7.27,505.15c-5.55,121.87-25.95,188.11-43,232.13-22.72,58.36-49.78,100-93.5,143.68s-85.42,70.78-143.78,93.5c-44,17.16-110.26,37.46-232.13,43-131.76,6.06-171.34,7.27-505.15,7.27s-373.28-1.21-505-7.27M1170.5,447.09c-133.07,6.06-224,27.16-303.41,58.06-82.19,31.91-151.86,74.72-221.43,144.18S533.39,788.47,501.48,870.76c-30.9,79.46-52,170.34-58.06,303.41-6.16,133.28-7.57,175.89-7.57,515.35s1.41,382.07,7.57,515.35c6.06,133.08,27.16,223.95,58.06,303.41,31.91,82.19,74.62,152,144.18,221.43s139.14,112.18,221.43,144.18c79.56,30.9,170.34,52,303.41,58.06,133.35,6.06,175.89,7.57,515.35,7.57s382.07-1.41,515.35-7.57c133.08-6.06,223.95-27.16,303.41-58.06,82.19-32,151.86-74.72,221.43-144.18s112.18-139.24,144.18-221.43c30.9-79.46,52.1-170.34,58.06-303.41,6.06-133.38,7.47-175.89,7.47-515.35s-1.41-382.07-7.47-515.35c-6.06-133.08-27.16-224-58.06-303.41-32-82.19-74.72-151.86-144.18-221.43S2586.8,537.06,2504.71,505.15c-79.56-30.9-170.44-52.1-303.41-58.06C2068,441,2025.41,439.52,1686,439.52s-382.1,1.41-515.45,7.57" fill="#ffffff" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const NETWORK_ICONS = {
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  tiktok: TikTokIcon,
  twitter: XIcon,
  whatsapp: WhatsAppIcon,
  youtube: YouTubeIcon,
};

// Donate variant: a 2-column grid of social-profile icon links.
function SocialGrid({ links }) {
  return (
    <div className="ty-social-grid">
      {links.map(({ network, url }) => {
        const Icon = NETWORK_ICONS[network];
        return (
          <a
            key={network}
            className={`ty-social-btn ty-social-btn--${network}`}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={network}
          >
            <Icon />
          </a>
        );
      })}
    </div>
  );
}

// Join variant: a stacked list of bilingual text links.
function LinkList({ links }) {
  return (
    <div className="ty-buttons">
      {links.map(({ he, ar, url }) => (
        <a key={url} className="ty-btn ty-btn--link" href={url} target="_blank" rel="noopener noreferrer">
          <span className="ty-btn-text">
            <span className="bi-he">{he}</span>{' '}
            <span className="bi-ar">{ar}</span>
          </span>
        </a>
      ))}
    </div>
  );
}

// Campaign variant: stacked buttons that share the campaign, each with its
// network's glyph. WhatsApp takes one free-text field, so the link rides along
// inside the message; Facebook only ever shares a URL (it ignores any prefilled
// text), and X/Twitter takes both separately.
const SHARE_HREF = {
  whatsapp: (text, url) => `https://api.whatsapp.com/send?text=${encodeURIComponent(`${text} ${url}`)}`,
  facebook: (text, url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  twitter: (text, url) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
};

function ShareList({ buttons, text, url }) {
  return (
    <div className="ty-buttons">
      {buttons.map((b, i) => {
        const Icon = NETWORK_ICONS[b.network];
        // A button labelled in one language shares that language's message;
        // the bilingual ones (Facebook / X) go out in Hebrew.
        const message = (b.lang === 'ar' ? text.ar : text.he) || '';
        return (
          <a
            key={i}
            className={`ty-btn ty-btn--share ty-btn--${b.network}`}
            href={SHARE_HREF[b.network](message, url)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="ty-btn-icon" aria-hidden="true"><Icon /></span>
            <span className="ty-btn-text">
              {b.he && <span className="bi-he">{b.he}</span>}
              {b.he && b.ar ? ' ' : null}
              {b.ar && <span className="bi-ar">{b.ar}</span>}
            </span>
          </a>
        );
      })}
    </div>
  );
}

// Campaign variant only: the optional donor-wall message, asked for AFTER the
// charge. The donation is already recorded by the time this renders, so the
// message is a separate follow-up write and nothing here can fail the donation
// — a submit that errors just leaves the field as it was, and the donor still
// has the share buttons below. Not rendered at all when the page passes no
// `onSubmitMessage` (i.e. it has no completed donation to attach one to).
function MessageForm({ copy, onSubmitMessage }) {
  const [text, setText] = useState('');
  const [state, setState] = useState('idle'); // 'idle' | 'sending' | 'sent'

  if (state === 'sent') {
    return (
      <p className="ty-msg-sent">
        <span className="bi-he">{copy.messageSent.he}</span>{' '}
        <span className="bi-ar">{copy.messageSent.ar}</span>
      </p>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    const value = text.trim();
    if (!value || state === 'sending') return;
    setState('sending');
    const ok = await onSubmitMessage(value);
    // On failure fall back to 'idle' so the donor can retry; the dialog never
    // reports an error, because by this point their donation already went through.
    setState(ok ? 'sent' : 'idle');
  };

  return (
    <form className="ty-msg" onSubmit={submit}>
      <label className="ty-msg-label">
        <span className="bi-he">{copy.messagePrompt.he}</span>{' '}
        <span className="bi-ar">{copy.messagePrompt.ar}</span>
      </label>
      <input
        className="ty-msg-input"
        maxLength={MESSAGE_MAX_LEN}
        value={text}
        onChange={(e) => setText(e.target.value)}
        disabled={state === 'sending'}
      />
      <span className="ty-msg-count">{text.length}/{MESSAGE_MAX_LEN}</span>
      <button className="ty-msg-send" type="submit" disabled={!text.trim() || state === 'sending'}>
        <span className="bi-he">{copy.messageSubmit.he}</span>{' '}
        <span className="bi-ar">{copy.messageSubmit.ar}</span>
      </button>
    </form>
  );
}

// `shareText` / `shareUrl` are only read by the campaign variant — donate and
// join share fixed profile links, not the page the donor came from.
export default function ThankYouModal({
  open,
  onClose,
  variant = 'donate',
  shareText,
  shareUrl,
  // Campaign variant only: async (message) => boolean. Omitted when there is no
  // completed donation to attach a message to, which hides the field entirely.
  onSubmitMessage,
}) {
  if (!open) return null;

  const s = share[variant];

  return (
    <div className="ty-overlay" onClick={onClose}>
      <div
        className={`ty-dialog${variant === 'donate' ? ' ty-dialog--donate' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="תודה شكرًا"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="ty-close" aria-label="סגירה إغلاق" onClick={onClose}>
          ✕
        </button>

        <h2 className="ty-thanks">
          <span className="ty-thanks-he">{s.thanks.he}</span>{' '}
          <span className="ty-thanks-ar">{s.thanks.ar}</span>
        </h2>

        <div className="ty-card">
          <p className="ty-subtitle">
            <span className="bi-he">{s.subtitle.he}</span>{' '}
            <span className="bi-ar">{s.subtitle.ar}</span>
          </p>
          {s.subtitle2 && (
            <p className="ty-subtitle">
              <span className="bi-he">{s.subtitle2.he}</span>{' '}
              <span className="bi-ar">{s.subtitle2.ar}</span>
            </p>
          )}

          {variant === 'campaign' && onSubmitMessage && (
            <MessageForm copy={s} onSubmitMessage={onSubmitMessage} />
          )}

          {variant === 'campaign' ? (
            <ShareList
              buttons={s.buttons}
              text={shareText || s.defaultText}
              url={shareUrl || window.location.href}
            />
          ) : variant === 'donate' ? (
            <SocialGrid links={s.links} />
          ) : (
            <LinkList links={s.links} />
          )}

          <a
            className="ty-logo"
            href="https://www.standing-together.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/logo-white.png" alt="עומדים ביחד نقف معًا" />
          </a>
        </div>
      </div>
    </div>
  );
}
